import { HttpUtilService, HttpClient } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';

export async function forceLogoutViaApi(
  baseUrl: string,
  authToken: string,
  agentId: string
): Promise<boolean> {
  const utilService = new HttpUtilService();
  const reqInit = utilService.initHeader(authToken, 'application/json');

  const forceLogoutUrl = `${baseUrl}/inContactAPI/services/v30.0/agents/${agentId}/force-logout`;
  logger.debug('[CXone SDK] Trying force-logout endpoint:', forceLogoutUrl);

  try {
    const forceLogoutResponse = await HttpClient.post(forceLogoutUrl, reqInit);
    logger.debug('[CXone SDK] force-logout response:', forceLogoutResponse);

    if (
      forceLogoutResponse &&
      forceLogoutResponse.status >= 200 &&
      forceLogoutResponse.status < 300
    ) {
      logger.debug('[CXone SDK] Force logout via API successful');
      await new Promise((resolve) => setTimeout(resolve, 1000));
      return true;
    }
  } catch (forceLogoutError: unknown) {
    const message =
      forceLogoutError instanceof Error ? forceLogoutError.message : String(forceLogoutError);
    logger.debug('[CXone SDK] force-logout endpoint failed:', message);
  }

  const agentStateUrl = `${baseUrl}/inContactAPI/services/v30.0/agents/${agentId}/state`;
  logger.debug('[CXone SDK] Fetching agent state from:', agentStateUrl);

  try {
    const stateResponse = await HttpClient.get(agentStateUrl, reqInit);
    logger.debug('[CXone SDK] Agent state response:', JSON.stringify(stateResponse?.data, null, 2));

    const sessionId = stateResponse?.data?.sessionId || stateResponse?.data?.SessionId;
    if (sessionId) {
      const endSessionUrl = `${baseUrl}/inContactAPI/services/v30.0/agent-sessions/${sessionId}?forceLogoff=true&endContacts=true&ignorePersonalQueue=true`;
      logger.debug('[CXone SDK] Ending session via DELETE:', endSessionUrl);

      const deleteResponse = await HttpClient.delete(endSessionUrl, reqInit);
      logger.debug('[CXone SDK] DELETE session response:', deleteResponse);
      return true;
    }
  } catch (stateError) {
    logger.debug('[CXone SDK] Agent state endpoint failed:', stateError);
  }

  return false;
}
